// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg fill=\"%23D9D9D9\" height=\"18\" viewBox=\"0 0 24 24\" width=\"18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m20.7071 6.29289c.3905.39053.3905 1.02369 0 1.41422l-10 9.99999c-.3905.3905-1.02368.3905-1.41421 0l-5-5c-.39052-.3905-.39052-1.0237 0-1.4142.39053-.3905 1.02369-.3905 1.41422 0l4.29289 4.2929 9.2929-9.29291c.3905-.39052 1.0237-.39052 1.4142 0z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hotkeys-modal .btn-close-modal {
  right: 1.2rem !important;
}
.hotkeys-modal .modal-content {
  max-width: 440px;
  margin: 0 auto;
}
.hotkeys-modal .modal-body {
  background-color: #0A0A0D;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: top center;
  padding: 12px 24px 24px 24px;
}
.hotkeys-modal .modal-dialog {
  max-width: 650px;
}
.hotkeys-modal .modal-dialog .hotkeys-body {
  font-size: 0.875rem;
}
.hotkeys-modal .modal-dialog .hotkeys-body [type=checkbox] {
  width: 20px;
  height: 20px;
  margin-top: 1px;
  border-radius: 6px;
  background-color: transparent;
  border: 1px solid var(--gray-750);
}
.hotkeys-modal .modal-dialog .hotkeys-body [type=checkbox]:checked {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat, var(--dice-primary-main);
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeys-items {
  padding: 0.5rem;
  border-radius: 8px;
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeys-items:not(:last-child) {
  margin-bottom: 1.25rem;
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeys-items:nth-child(odd) {
  background-color: var(--primary-95);
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeys-items .hotkeys-col-1 {
  padding: 0 0.5rem;
  border-radius: 8px;
  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);
  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.4), 0px 1px 0px 0px rgba(239, 116, 3, 0.6) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.3) inset, 0px 0px 15px 0px #EF7403 inset;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  border: 0;
  padding: 10px 10px;
  min-height: 41px;
  color: var(--white-100);
  min-width: 32px;
  min-height: 32px;
  border-radius: 8px;
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeys-items .hotkeys-col-1.space {
  min-width: 39px;
  padding: 0.5rem 0.725rem;
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeys-items .hotkeys-col-2 {
  width: 100%;
}
.hotkeys-modal .modal-dialog .hotkeys-body .checkbox-hotkeys {
  margin-bottom: 1.25rem;
  cursor: pointer;
}
.hotkeys-modal .modal-dialog .hotkeys-body .checkbox-hotkeys::selection {
  background-color: var(--dice-neutral-600);
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeays-warning-section {
  margin-top: 12px;
}
.hotkeys-modal .modal-dialog .hotkeys-body .hotkeays-warning-section p {
  color: #A1A1AA;
  font-size: 0.75rem;
}
.hotkeys-modal .hotkey-modal-btn {
  width: 100%;
  line-height: 44px;
  min-height: 44px;
  border-radius: 8px;
  border: 1px solid var(--white);
  background-color: transparent !important;
  color: var(--white);
  margin: 12px 0;
}`, "",{"version":3,"sources":["webpack://./src/games/Plinko/GameTheme/PyramidPlinkoGame/components/HotkeysModal/hotkeysmodal.scss"],"names":[],"mappings":"AAgBE;EACE,wBAAA;AAfJ;AAiBE;EACE,gBAAA;EACA,cAAA;AAfJ;AAiBE;EACE,yBAAA;EACA,4BAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;AAfJ;AAiBE;EACE,gBAAA;AAfJ;AAgBI;EACE,mBAAA;AAdN;AAeM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,iCAAA;AAbR;AAcQ;EACE,uFAAA;AAZV;AAeM;EACE,eAAA;EACA,kBAAA;AAbR;AAcQ;EACE,sBAAA;AAZV;AAeQ;EACE,mCAAA;AAbV;AAgBQ;EACE,iBAAA;EAxDR,kBAAA;EACA,6DAAA;EACA,kLAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EA+CQ,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAHV;AAIU;EACE,eAAA;EACA,wBAAA;AAFZ;AAKQ;EACE,WAAA;AAHV;AAMM;EACE,sBAAA;EACA,eAAA;AAJR;AAKQ;EACE,yCAAA;AAHV;AAMM;EACE,gBAAA;AAJR;AAKQ;EACE,cAAA;EACA,kBAAA;AAHV;AAQE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;AANJ","sourcesContent":["@mixin BetButton {\n  border-radius: 8px;\n  background: linear-gradient(180deg, #FF9F45 0%, #EF7403 100%);\n  box-shadow: 0px 0px 10px 0px rgba(255, 159, 69, 0.40), 0px 1px 0px 0px rgba(239, 116, 3, 0.60) inset, 0px -3px 0px 0px rgba(255, 159, 69, 0.30) inset, 0px 0px 15px 0px #EF7403 inset;\n  color: #FFF;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  border: 0;\n  padding: 10px 10px;\n  min-height: 41px;\n}\n\n.hotkeys-modal {\n  .btn-close-modal {\n    right: 1.2rem !important;\n  }\n  .modal-content{\n    max-width: 440px;\n    margin: 0 auto;\n  }\n  .modal-body{\n    background-color: #0A0A0D;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    background-position: top center;\n    padding: 12px 24px 24px 24px;\n  }\n  .modal-dialog {\n    max-width: 650px;\n    .hotkeys-body {\n      font-size: 0.875rem;\n      [type=checkbox] {\n        width: 20px;\n        height: 20px;\n        margin-top: 1px;\n        border-radius: 6px;\n        background-color: transparent;\n        border: 1px solid var(--gray-750);\n        &:checked {\n          background: url('data:image/svg+xml,<svg fill=\"%23D9D9D9\" height=\"18\" viewBox=\"0 0 24 24\" width=\"18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m20.7071 6.29289c.3905.39053.3905 1.02369 0 1.41422l-10 9.99999c-.3905.3905-1.02368.3905-1.41421 0l-5-5c-.39052-.3905-.39052-1.0237 0-1.4142.39053-.3905 1.02369-.3905 1.41422 0l4.29289 4.2929 9.2929-9.29291c.3905-.39052 1.0237-.39052 1.4142 0z\"/></svg>') no-repeat,var(--dice-primary-main);\n        }\n      }\n      .hotkeys-items {\n        padding: 0.5rem;\n        border-radius: 8px;\n        &:not(:last-child) {\n          margin-bottom: 1.25rem;\n        }\n\n        &:nth-child(odd){\n          background-color: var(--primary-95);\n        }\n\n        .hotkeys-col-1 {\n          padding: 0 .5rem;\n          @include BetButton();\n          color: var(--white-100);\n          min-width: 32px;\n          min-height: 32px;\n          border-radius: 8px;\n          &.space {\n            min-width: 39px;\n            padding: 0.5rem 0.725rem;\n          }\n        }\n        .hotkeys-col-2 {\n          width: 100%;\n        }\n      }\n      .checkbox-hotkeys {\n        margin-bottom: 1.25rem;\n        cursor: pointer;\n        &::selection {\n          background-color: var(--dice-neutral-600);\n        }\n      }\n      .hotkeays-warning-section {\n        margin-top: 12px;\n        p {\n          color: #A1A1AA;\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n  .hotkey-modal-btn {\n    width: 100%;\n    line-height: 44px;\n    min-height: 44px;\n    border-radius: 8px;\n    border: 1px solid var(--white);\n    background-color: transparent !important;\n    color: var(--white);\n    margin: 12px 0;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
